module.exports = __webpack_public_path__ + "static/media/alert.a33c5e50.mp3";